import { Reveal } from "@/components/Reveal";

export const SectionHeader = ({ index, eyebrow, title, description }) => (
  <Reveal className="max-w-3xl mb-16 sm:mb-24">
    <p className="text-xs tracking-[0.3em] uppercase text-titanium mb-6">
      <span className="text-white">{index}</span> <span className="mx-2 text-[#3a3d44]">/</span> {eyebrow}
    </p>
    <h2 className="font-extrabold tracking-[-0.04em] leading-[1] text-4xl sm:text-5xl lg:text-6xl">{title}</h2>
    {description && <p className="mt-6 text-base sm:text-lg text-titanium leading-relaxed max-w-xl">{description}</p>}
  </Reveal>
);
